import { css } from 'styled-components';
import { height, color, padding, rgbaColor } from '../mixins';
import theme from '../theme';

export default css`
  .PhoneInput {
    height: calc(${height('md')} - 2px);
    transition: 0.3s;
    border: 1px solid ${color('gray')};
    border-radius: ${theme.radii.md}px;
    font-size: ${theme.typography.sizes.md}px;
    font-family: ${theme.typography.family};
    padding: 0 ${padding('sm')};
    width: 100%;

    .PhoneInputInput {
      border: none !important;
      outline: none !important;

      &:disabled {
        background: transparent !important;
      }
    }
  }

  .PhoneInput--focus {
    border-color: ${color('primary')};
    border-radius: ${theme.radii.sm}px;
    box-shadow: 0 0 0 2px ${rgbaColor('primary', 0.2)};
  }

  .PhoneInput--disabled {
    background: ${color(['gray', '200'])};
    color: rgba(0, 0, 0, 0.25);
  }

  .PhoneInputCountryIcon {
    box-shadow: none !important;
    background: none !important;
  }

  .PhoneInputCountrySelectArrow {
    color: inherit !important;
  }

  .ant-form-item-has-error {
    .form-control {
      border-color: ${color('error')} !important;
    }
  }
`;
